import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { baseColors, baseStyles } from "../baseStyles";
import { changePassword } from "../general_functions/general";
import { FormHelperText } from "@material-ui/core";

export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: ""
    };
  }

  handleWipeButton() {
    this.setState({
      currentPassword: "",
      newPassword: "",
      confPassword: "",
    });
  }

  handleSaveButton(e) {
    e.preventDefault();
    let { currentPassword, newPassword, confPassword } = this.state;
    //Check if the password match.
    if (newPassword != confPassword) {
      this.props.handleSnackbar(
        "Passwords not much"
      );
      return;
    }

    let { username, _id } = this.props.context.state.session.user;
    console.log(this.props.context.state)
    let data = {
      username: username,
      oldPassword: currentPassword,
      newPassword,
      _id: _id,
    };

    if (newPassword === confPassword) {
      changePassword(data, res => {
        if (res) {
          this.props.handleSnackbar(
            "Your password has been chaneged succesfuly!"
          );
        }
      });
    } else {
      this.props.handleSnackbar(
        "Passwords are wrong!"
      );
    }
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    return (
      <div style={{ marginTop: 120 }}>
        <div className={"wrapper"}>
          <div style={baseStyles.baseTextHeaderWrapper}>
            <h3 style={{
              color: baseColors.bgRed,
              paddingTop: 24
            }}>
              {"Change Password"}
            </h3>
          </div>
          <div>
            <form onSubmit={this.handleSaveButton.bind(this)}>
              <div style={{ display: "flex", flexWrap: "wrap", alignItems: "baseline" }}>
                <TextField
                  style={{ margin: 8 }}
                  label="Current Password"
                  type="password"
                  autoComplete="current-password"
                  value={this.state.currentPassword}
                  onChange={this.handleChange('currentPassword')}
                  required
                />
                <TextField
                  style={{ margin: 8 }}
                  label="New Password"
                  type="password"
                  autoComplete="new-password"
                  value={this.state.newPassword}
                  onChange={this.handleChange('newPassword')}
                  required
                />
                <TextField
                  style={{ margin: 8 }}
                  value={this.state.confPassword}
                  onChange={this.handleChange('confPassword')}
                  label="Conferm-password"
                  type="password"
                  required
                />
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleSaveButton.bind(this)}>
                    Change
                </Button>
                </div>
              </div>
            </form>
            <br />
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  customWidth: {
    width: 460
  },
  privilegeContent: {
    widht: 200
  }
};
